import { $k18n } from '@/common/i18n';
import { withZeroText } from '@/common/utils/withZeroText';
import { Box, Flex } from '@kibt/meta-ui-krn';
import { useCountDown } from 'ahooks';
import dayjs from 'dayjs';
import React from 'react';
import { ViewStyle, Text, TextStyle } from 'react-native';
interface CountDownTagProps {
    leftTime: number;
    endTimeStamp: number;
    onlyShowLessThan24h?: boolean;
    hideCountDownLang?: boolean;
    hideCountDownText?: boolean;
    showDot?: boolean;
    boxStyle?: ViewStyle;
    textStyle?: TextStyle;
    allTextStyle?: TextStyle;
    useTargetTime?: boolean;
    onEnd?: () => void;
}
function CountDownText({ leftTime, targetDate, onEnd }: { targetDate: number; leftTime: number; onEnd?: () => void }) {
    const [_, formateTime] = useCountDown({
        ...(!targetDate ? { leftTime: leftTime } : {}),
        targetDate,
        onEnd,
    });

    const timeText = `${withZeroText(formateTime.hours)}:${withZeroText(formateTime.minutes)}:${withZeroText(formateTime.seconds)}`;
    return <>{timeText}</>;
}
export function CountDownTag({
    leftTime,
    endTimeStamp,
    hideCountDownText,
    onlyShowLessThan24h,
    hideCountDownLang,
    boxStyle,
    textStyle,
    allTextStyle,
    useTargetTime,
    onEnd,
}: CountDownTagProps) {
    const less24hours = leftTime < 24 * 60 * 60 * 1000;
    if (onlyShowLessThan24h && !less24hours) return null;
    const countDownLang = hideCountDownLang ? '' : ` ${'·'} ${$k18n({ id: 'k_367076', text: '倒计时' })}`;
    if (hideCountDownText)
        return (
            <Box bs={{ py: 2.5, px: 4, borderRadius: 3, bg: 'rgba(255, 73, 6, 0.12)', ...(boxStyle ?? {}) }}>
                <Text style={{"fontSize":"2.6570048309178746rem","color":"rgb(255, 73, 6)"}}>
                    {$k18n({ id: 'k_513882', text: '百万补贴' })}
                    {countDownLang}
                </Text>
            </Box>
        );
    return (
        <Flex flex={'flexRowCenter'} bs={{ py: 2.5, px: 4, borderRadius: 3, bg: 'rgba(255, 73, 6, 0.12)', ...(boxStyle ?? {}) }}>
            <Box>
                <Text style={[{ fontSize: 11, color: 'rgb(255, 73, 6)' }, textStyle, allTextStyle]}>
                    {$k18n({ id: 'k_513882', text: '百万补贴' })}
                    {countDownLang}
                </Text>
            </Box>
            <Box bs={{}}>
                <Text style={[{ fontSize: 11, color: 'rgb(255, 73, 6)' }, allTextStyle]}>
                    &nbsp;
                    {less24hours ? (
                        <CountDownText leftTime={leftTime} onEnd={onEnd} targetDate={useTargetTime ? endTimeStamp : 0} />
                    ) : (
                        dayjs(endTimeStamp).format('DD/MM/YYYY')
                    )}
                </Text>
            </Box>
        </Flex>
    );
}
